import gql from "graphql-tag";

export default gql`
    mutation ($productId: ID!) {
        deleteProduct (productId: $productId) {
            success
        }
    }
`;
